// TODO: remove everything related to tags to make this reusable
import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import Paper from "@material-ui/core/Paper";
import Checkbox from "@material-ui/core/Checkbox";
import clsx from "clsx";
import { IconButton, Divider, Tooltip } from "@material-ui/core";
import OptimizedTooltip from "./OptimizedTooltip";

import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import { Skeleton } from "@material-ui/lab";

function descendingComparator(a, b, orderBy, type) {
  let aVal = a[orderBy];
  let bVal = b[orderBy];
  if (type === "string") {
    aVal = aVal?.toLowerCase();
    bVal = bVal?.toLowerCase();
  }
  if (bVal < aVal) {
    return -1;
  }
  if (bVal > aVal) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b, type) => descendingComparator(a, b, orderBy, type)
    : (a, b, type) => -descendingComparator(a, b, orderBy, type);
}

function stableSort(array, comparator, type) {
  const stabilizedThis = array.map((el, index) => [el, index]);

  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0], type);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map(el => el[0]);
}

const headCells = [
  {
    id: "name",
    numeric: false,
    disablePadding: true,
    label: "Name"
  },
  { id: "type", numeric: true, disablePadding: false, label: "Type" }
];

function EnhancedTableHead(props) {
  const {
    classes,
    onSelectAllClick,
    order,
    orderBy,
    numSelected,
    rowCount,
    onRequestSort
  } = props;
  const createSortHandler = property => event => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow className={classes.header}>
        <TableCell padding="checkbox">
          <div className={classes.checkboxWrapper}>
            <Checkbox
              indeterminate={numSelected > 0 && numSelected < rowCount}
              checked={rowCount > 0 && numSelected === rowCount}
              onChange={onSelectAllClick}
              color="primary"
              id='selectAll-tags'
            />
            <Divider orientation="vertical" />
          </div>
        </TableCell>
        {headCells.map(headCell => (
          <TableCell
            key={headCell.id}
            align={"left"}
            padding={headCell.disablePadding ? "none" : "default"}
            sortDirection={orderBy === headCell.id ? order : false}
            className={classes.headerTitle}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <span className={classes.visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

const useStyles = makeStyles(theme => ({
  root: {
    width: "100%",
    overflow: "auto"
  },
  paper: {
    width: "100%",
    marginBottom: theme.spacing(2)
  },
  visuallyHidden: {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: 1,
    margin: -1,
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    top: 20,
    width: 1
  },
  table: {
    tableLayout: "fixed",
    paddingTop: 0,
    "& .item-actions-wrapper": {
      opacity: 0
    },
    "& .MuiTableRow-hover:hover": {
      backgroundColor: "#eee",
      "& .item-actions-wrapper": {
        opacity: 1
      }
    },
    "& .MuiCheckbox-root svg": {
      color: "inherit"
    },
    "& .MuiTableCell-paddingCheckbox": {
      width: "63px"
    },
    "& .MuiTableCell-head": {
      position: "sticky",
      top: 0,
      zIndex: 15,
      border: "none",
      backgroundColor: "#F7F7F7",
      "&::after, &::before": {
        left: 0,
        width: "100%",
        height: "1px",
        content: '""',
        position: "absolute",
        fontSize: 0,
        backgroundColor: "#eee"
      },
      "&::before": {
        top: 0
      },
      "&::after": {
        bottom: 0
      }
    }
  },

  checkboxWrapper: {
    padding: theme.spacing(0, 0, 0, 1.5),
    display: "flex",
    justifyContent: "space-between",
    // position: "relative",
    "& .MuiDivider-root": {
      content: '""',
      height: theme.spacing(3),
      marginLeft: theme.spacing(0.5),
      width: 1,
      backgroundColor: "#DDD",
      margin: "auto"
    }
  },

  menuItem: {
    height: 48,
    padding: theme.spacing(1.25, 0, 1.25, 3),
    borderBottom: "1px solid #ddd",
    position: "relative"
  },
  itemActions: {
    position: "absolute",
    right: 24,
    zIndex: 5,
    top: 0,
    height: "40px",
    bottom: 0,
    margin: "auto"
  },

  tableCell: {
    fontSize: "0.9375rem",
    padding: theme.spacing(0, 2),
    lineHeight: "1.125rem",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    overflow: "hidden",
    "&:last-child": {
      // TODO: move to parent
      width: 175
    }
  },
  header: {
    height: 48
  },
  headerTitle: {
    fontSize: "0.75rem",
    lineHeight: "0.875rem",
    padding: theme.spacing(0, 2),
    color: "#808080"
  },
  tooltip: {
    backgroundColor: "#fff",
    color: theme.palette.text.primary,
    fontSize: "0.8125rem",
    lineHeight: "1.1875rem",
    fontWeight: 400,
    boxShadow: "0px 2px 12px rgba(0, 0, 0, 0.24)",
    padding: theme.spacing(1.5),
    maxWidth: "216px"
  }
}));

export default function CommonTable({
  rows,
  selected,
  setSelected,
  handleDelete,
  label,
  loading,
  setCurrentItem,
  setCurrentAction,
  setConfirmDialogState,
  searchInputValue
}) {
  const classes = useStyles();
  const [order, setOrder] = useState("desc");
  const [orderBy, setOrderBy] = useState("calories");
  // const [selected, setSelected] = useState([]);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleSelectAllClick = event => {
    if (event.target.checked) {
      const newSelected = rows.map(n => n.id);
      setSelected(newSelected);
      return;
    }
    setSelected([]);
  };

  const handleChange = (event, id) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }

    setSelected(newSelected);
  };

  const emptyRows = rows.length ? 0 : 1;

  return (
    <div className={classes.root}>
      <Paper className={classes.paper} elevation={0}>
        <Table className={classes.table}>
          <EnhancedTableHead
            classes={classes}
            numSelected={selected.length}
            order={order}
            orderBy={orderBy}
            onSelectAllClick={handleSelectAllClick}
            onRequestSort={handleRequestSort}
            rowCount={rows.length}
          />
          <TableBody>
            {loading ? (
              <TableRow>
                <TableCell align="center" colSpan={3}>
                  <Skeleton />
                  <Skeleton />
                </TableCell>
              </TableRow>
            ) : (
              <>
                {stableSort(rows, getComparator(order, orderBy), "string").map(
                  (row, index) => {
                    return (
                      <TableRow
                        hover
                        // onClick={event => handleClick(event, row.name)}
                        role="checkbox"
                        tabIndex={-1}
                        key={row.id}
                        className={classes.menuItem}
                        id={`tagsListRow-${row.name}`}
                      >
                        <TableCell padding="checkbox">
                          <div className={classes.checkboxWrapper}>
                            <Checkbox
                              color="primary"
                              checked={selected.includes(row.id)}
                              onChange={e => handleChange(e, row.id)}
                              id={`tagCheckbox-${row.name}`}
                            />
                            <Divider orientation="vertical" />
                          </div>
                          <div
                            className={clsx(
                              classes.itemActions,
                              "item-actions-wrapper"
                            )}
                          >
                            <IconButton
                              component="button"
                              onClick={() => {
                                setCurrentAction("edit");
                                setCurrentItem(row);
                              }}
                              tabIndex="-1"
                              data-cy={`edit-${label}`}
                            >
                              <OptimizedTooltip
                                placement="bottom"
                                title="Edit"
                                enterDelay={200}
                                enterNextDelay={200}
                              >
                                <EditIcon />
                              </OptimizedTooltip>
                            </IconButton>
                            <IconButton
                              component="button"
                              onClick={() => {
                                setConfirmDialogState({
                                  open: true,
                                  id: row.id,
                                  title: `Delete ${label}?`,
                                  body: `Are you sure you want to permanently delete this ${label}?`,
                                  action: () => handleDelete(row)
                                });
                              }}
                              tabIndex="-1"
                              data-cy={`delete-${label}`}
                            >
                              <OptimizedTooltip
                                placement="bottom"
                                title="Delete"
                                enterDelay={200}
                                enterNextDelay={200}
                              >
                                <DeleteIcon />
                              </OptimizedTooltip>
                            </IconButton>
                          </div>
                        </TableCell>
                        <TableCell
                          className={classes.tableCell}
                          component="th"
                          scope="row"
                          padding="none"
                        >
                          <Tooltip
                            title={row.name}
                            placement="bottom-start"
                            classes={{ tooltip: classes.tooltip }}
                            enterDelay={1000}
                          >
                            <span id='tagRowName' >{row.name}</span>
                          </Tooltip>
                        </TableCell>
                        <TableCell
                            className={classes.tableCell}
                            id='tagRowType'
                        >
                          {row.type}
                        </TableCell>
                      </TableRow>
                    );
                  }
                )}
                {emptyRows > 0 && (
                  <TableRow style={{ height: 53 * emptyRows }}>
                    <TableCell align="center" colSpan={3}>
                      {searchInputValue.length
                        ? `No ${label}s matched your search`
                        : `No ${label}s to display`}
                    </TableCell>
                  </TableRow>
                )}
              </>
            )}
          </TableBody>
        </Table>
      </Paper>
    </div>
  );
}
